var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8516 12C17.8516 12.3281 17.724 12.6016 17.4688 12.8203C17.25 13.0391 16.9766 13.1484 16.6484 13.1484H5L0.351562 17.8516V1.5C0.351562 1.17188 0.460938 0.898438 0.679688 0.679688C0.898438 0.460938 1.17188 0.351562 1.5 0.351562H16.6484C16.9766 0.351562 17.25 0.460938 17.4688 0.679688C17.724 0.898438 17.8516 1.17188 17.8516 1.5V12ZM22.5 5C22.8281 5 23.1016 5.10938 23.3203 5.32812C23.5391 5.54688 23.6484 5.82031 23.6484 6.14844V23.6484L19 19H6.14844C5.82031 19 5.54688 18.8906 5.32812 18.6719C5.10938 18.4531 5 18.1797 5 17.8516V15.5H20.1484V5H22.5Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessage);
export default __webpack_public_path__ + "static/media/ic_message.6848ccb3359f93c2340545f724ec79b1.svg";
export { ForwardRef as ReactComponent };